'use client';

import Link from 'next/link';
import Container from '@/components/ui/container';
import { Star, StarHalf } from 'lucide-react';
import { useGoogleReviews } from '@/context/GoogleReviewsContext';

// Star rating helper
function getStarRating(rating: number, maxStars: number = 5): ('full' | 'half' | 'empty')[] {
	const stars: ('full' | 'half' | 'empty')[] = [];
	const fullStars = Math.floor(rating);
	const hasHalfStar = rating - fullStars >= 0.25 && rating - fullStars < 0.75;
	const hasFullInsteadOfHalf = rating - fullStars >= 0.75;

	for (let i = 0; i < maxStars; i++) {
		if (i < fullStars) {
			stars.push('full');
		} else if (i === fullStars && hasFullInsteadOfHalf) {
			stars.push('full');
		} else if (i === fullStars && hasHalfStar) {
			stars.push('half');
		} else {
			stars.push('empty');
		}
	}

	return stars;
}

const TopBar = () => {
	// Use shared Google Reviews context
	const googleData = useGoogleReviews();
	const stars = getStarRating(googleData.rating);

	return (
		<div className="bg-blue text-white py-2 text-sm font-medium">
			<Container className="flex flex-col md:flex-row items-center justify-between gap-2">
				{/* Left: Google Rating */}
				<div className="flex items-center gap-2">
					<div className="flex text-yellow-400 gap-0.5">
						{stars.map((star, i) =>
							star === 'full' ? (
								<Star key={i} className="size-4 fill-current" />
							) : star === 'half' ? (
								<StarHalf key={i} className="size-4 fill-current" />
							) : (
								<Star key={i} className="size-4" />
							),
						)}
					</div>
					<span>
						{googleData.rating.toFixed(1)}/5 sterren (<a href="https://maps.google.com/?cid=4464300248615167290&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA" target="_blank" rel="noreferrer" className="underline hover:no-underline hover:text-white/80 transition-colors">{googleData.reviewCount}+ Google reviews</a>)
					</span>
				</div>

				{/* Right: Sub Navigation */}
				<nav className="hidden md:flex items-center gap-6">
					<Link href="/over-ons" className="hover:text-white/80 transition-colors">
						Over ons
					</Link>
					<Link href="/werken-bij" className="hover:text-white/80 transition-colors">
						Werken bij
					</Link>
					<Link href="/advies" className="hover:text-white/80 transition-colors">
						Advies & Inspiratie
					</Link>
					<Link href="/contact" className="hover:text-white/80 transition-colors">
						Showroom
					</Link>
				</nav>
			</Container>
		</div>
	);
};

export default TopBar;
